import {
  CTAWithImageSection,
  CTAWithImageStyles,
} from '@exploration/shared-sections';
import { desktop } from '@thrivent/midwest-shared';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const Highlight = styled(CTAWithImageSection)`
  ${CTAWithImageStyles.Title} {
    max-width: 32rem;
  }
`;
export const HighlightBanner = styled(CTAWithImageSection)`
  ${desktop} {
    box-shadow: inset 0 9.5rem 0 0 ${(p) => p.theme.midwestColors.white};
  }

  ${CTAWithImageStyles.Title} {
    max-width: 32rem;
  }

  ${CTAWithImageStyles.TextContainer} {
    ${desktop} {
      grid-column-start: ${(p) =>
        p.reverseDesktop ? 'main-left-offset' : 'main'};
      grid-column-end: ${(p) =>
        p.reverseDesktop ? 'main-right 4' : 'main-left-stop'};
    }

    ${CTAWithImageStyles.Button} {
      ${desktop} {
        display: none;
      }
    }
  }

  ${CTAWithImageStyles.Image} {
    ${desktop} {
      width: 50%;
      object-fit: contain;
      margin-top: 3rem;
    }
  }
`;
